import type { Cultivar } from '../types/cultivar';

type QuarantineFields = Pick<Cultivar, 'quarantine_entry_date' | 'quarantine_release_date' | 'quarantine_released'>;

/**
 * One sentence on where a cultivar stands with post-entry quarantine, or null
 * when it was never in it. `fmt` turns a YYYY-MM-DD date into display text.
 * A release date means released; released with no date is a legacy record
 * that never kept one.
 */
export function quarantineSummary(c: QuarantineFields, fmt: (date: string) => string): string | null {
  const entry = c.quarantine_entry_date?.slice(0, 10) || null;
  const release = c.quarantine_release_date?.slice(0, 10) || null;
  if (release) {
    return entry ? `Released ${fmt(release)} (entered ${fmt(entry)})` : `Released ${fmt(release)}`;
  }
  if (c.quarantine_released) {
    return entry ? `Released, date not recorded (entered ${fmt(entry)})` : 'Released, date not recorded';
  }
  return entry ? `In quarantine since ${fmt(entry)}` : null;
}
